import React from 'react';
import { TrendingUp, Mail, Calendar, AlertCircle, Clock, Users } from 'lucide-react';

const AdminAnalytics = ({ analytics, onNavigate }) => {
  if (!analytics || !analytics.clients) return null;

  const clients = analytics.clients;
  
  // Calculate aggregate stats
  const totalClients = clients.length;
  const activeClients = clients.filter(c => c.engagement_score > 20).length;
  const upcomingWeddings = clients.filter(c => c.days_until_wedding >= 0 && c.days_until_wedding <= 30).length;
  const thisWeekWeddings = clients.filter(c => c.days_until_wedding >= 0 && c.days_until_wedding <= 7).length;
  const totalEmailsSent = clients.reduce((sum, c) => sum + (c.emails_sent || 0), 0);
  const avgEngagement = totalClients > 0 ? Math.round(clients.reduce((sum, c) => sum + c.engagement_score, 0) / totalClients) : 0;

  return (
    <div className="space-y-6">
      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl p-5 text-white">
          <div className="flex items-center justify-between mb-3">
            <Users size={20} className="opacity-80" />
            <span className="text-2xl font-bold">{activeClients}</span>
          </div>
          <p className="text-sm opacity-90">Active Clients</p>
          <p className="text-xs opacity-70 mt-1">High engagement</p>
        </div>

        <div className="bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl p-5 text-white">
          <div className="flex items-center justify-between mb-3">
            <Calendar size={20} className="opacity-80" />
            <span className="text-2xl font-bold">{upcomingWeddings}</span>
          </div>
          <p className="text-sm opacity-90">Next 30 Days</p>
          <p className="text-xs opacity-70 mt-1">Upcoming weddings</p>
        </div>

        <div className="bg-gradient-to-br from-red-600 to-rose-700 rounded-xl p-5 text-white">
          <div className="flex items-center justify-between mb-3">
            <AlertCircle size={20} className="opacity-80" />
            <span className="text-2xl font-bold">{thisWeekWeddings}</span>
          </div>
          <p className="text-sm opacity-90">This Week</p>
          <p className="text-xs opacity-70 mt-1">Needs attention</p>
        </div>

        <button
          onClick={() => onNavigate('/admin/email-clients')}
          className="bg-gradient-to-br from-green-600 to-emerald-700 rounded-xl p-5 text-white hover:scale-105 transition-all cursor-pointer text-left w-full"
        >
          <div className="flex items-center justify-between mb-3">
            <Mail size={20} className="opacity-80" />
            <span className="text-2xl font-bold">{totalEmailsSent}</span>
          </div>
          <p className="text-sm opacity-90">Emails Sent</p>
          <p className="text-xs opacity-70 mt-1">Total communication →</p>
        </button>
      </div>

      {/* Client Engagement Overview - Focus on engagement and planning status */}
      <div className="bg-[#1C1917] rounded-xl p-6 border border-white/10">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-white">Client Engagement Overview</h3>
          <TrendingUp className="text-green-400" size={20} />
        </div>
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-2xl font-bold text-white">{avgEngagement}</p>
            <p className="text-xs text-white/50">Avg Engagement Score</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-white">{Math.round((activeClients / totalClients) * 100)}%</p>
            <p className="text-xs text-white/50">Active Rate</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-white">{totalClients}</p>
            <p className="text-xs text-white/50">Total Clients</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAnalytics;